import { addLikeToMessage } from 'controllers/SocialServiceController'
import { setPlayList } from 'redux/actions/messagesActions'
import { canLikePost, isAnonymousAccess } from './transactionUtils'

export const addMessageLike = async (user, message, playList, dispatch) => {
    const { _id: messageId, userId, accessType } = message
    if (canLikePost(user, userId, isAnonymousAccess(accessType))) {
        const updatedMessage = await addLikeToMessage(messageId)
        //console.log('like updatedMessage', updatedMessage)
        const likedIx = playList.findIndex(pl => pl.messageId === messageId)
        if (likedIx !== -1) {
            const { numLikes, liked } = updatedMessage
            const newEntry = { ...message, numLikes, liked }
            const update = [
                ...playList.slice(0, likedIx),
                newEntry,
                ...playList.slice(likedIx + 1),
            ]
            //console.log('...newEntry', newEntry)
            dispatch(setPlayList(update))
        }
    }
}